import { Injectable } from '@angular/core';
import {AuthService, User} from "@auth0/auth0-angular";
import {lastValueFrom} from "rxjs";
import { Utente } from '../models/latitude/utente.model';
import { UtentiService } from './latitude/utenti/utenti.service';
import { NGXLogger } from 'ngx-logger';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private userData: Utente;
  public isSuperAdmin:boolean   = false;
  public isAdmin:boolean        = false;
  public isUtente:boolean        = false;

  public ruoloStr: string;

  constructor(
    private auth: AuthService,
    private utenti: UtentiService,
    private logger: NGXLogger,
    private router: Router
  ) {
    this.userData = null;
  }

  async loadSetUserInformation (user: User) {
    this.logger.info("* loadSetUserInformation *");
    this.logger.info(user);
    
    const idAuth0:string = user.sub.slice(user.sub.indexOf('|')+1);
    
    try {
      const utente = await lastValueFrom(this.utenti.getByIdAuth0(idAuth0));
      this.setUser(utente);

      // Verifica se l'utente è bloccato
      if (utente && utente.attivo === false) {
        const errorMessage = `Accesso negato: l'utente ${user.name || user.email} è bloccato e non può accedere al sistema.`;
        console.error('[AUTH ERROR]', errorMessage, {
          userId: idAuth0,
          userEmail: user.email,
          userName: user.name,
          attivo: utente.attivo
        });
        this.logger.error(errorMessage, {
          userId: idAuth0,
          userEmail: user.email,
          userName: user.name,
          attivo: utente.attivo
        });

        // Pulisci i dati locali
        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("ruolo");
        localStorage.removeItem("idUtente");
        localStorage.removeItem("utente");
        
        // Logout da Auth0
        this.auth.logout({
          logoutParams: {
            returnTo: window.location.origin + '/login'
          }
        });

        // Reindirizza alla pagina di login
        this.router.navigate(['/login']);
        
        throw new Error(errorMessage);
      }

      this.ruoloStr = user["https://latitude.map-hosting.it/roles"][0];
      this.setRoleFromAuth0(this.ruoloStr);
      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("ruolo", this.ruoloStr);
      localStorage.setItem("idUtente", user.sub.slice(user.sub.indexOf('|') + 1));
      localStorage.setItem("utente", user.name);
    } catch (error) {
      // Se l'errore è già stato gestito (utente bloccato), rilancia
      if (error instanceof Error && error.message.includes('bloccato')) {
        throw error;
      }
      
      // Gestisci altri errori
      this.logger.error('Errore durante il caricamento delle informazioni utente', error);
      console.error('[AUTH ERROR] Errore durante il caricamento delle informazioni utente:', error);
      throw error;
    }
  }

  setUser(user: Utente) {
    this.userData = user;
    //this.logger.info("* setUser *");
  }

  public setRoleFromAuth0(role:string){
    // Reset di tutti i flag prima di impostare il nuovo ruolo
    this.isSuperAdmin = false;
    this.isAdmin = false;
    this.isUtente = false;

    this.logger.info("* setRoleFromAuth0: "+ role);

    if(role==='SUPERADMIN'){
        this.isSuperAdmin = true;
        this.logger.info("* Ruolo impostato: SUPERADMIN");
    }else if(role==='ADMIN'){
        this.isAdmin = true;
        this.logger.info("* Ruolo impostato: ADMIN");
    }else if(role==='UTENTE'){
        this.isUtente = true;
        this.logger.info("* Ruolo impostato: UTENTE");
    }
    
    this.logger.info("* setRoleFromAuth0 - isSuperAdmin: "+ this.isSuperAdmin + " isAdmin: "+ this.isAdmin + " isUtente: "+ this.isUtente);
  }


  getUser(): Utente {
    return this.userData;
  }
}
